import { SpaceHeaderTitleDropdownFullScreen } from "@/react/components/Spaces/Header/SpaceHeaderTitleDropdown/SpaceHeaderTitleDropdownFullScreen";
import type { Space } from "@/react/types/Space";
import { useSmScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { useMobileWebFlags } from "@circle-react/hooks/useMobileWebFlags";
import { Icon } from "@circle-react-shared/Icon";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { useSpaceCustomizationModal } from "../SpaceCustomizationModal";
import { SpaceTitleWithEmoji } from "./SpaceTitleWithEmoji";

interface ConditionallyRenderSpaceHeaderTitleProps {
  isAdmin: boolean;
  isMember: boolean;
  onClickAddCoverImage: () => void;
  setIsAddMemberOpen: (isOpen: boolean) => void;
  shouldShowMembersCount?: boolean;
  space: Space;
}

export const ConditionallyRenderSpaceHeaderTitle = ({
  space,
  shouldShowMembersCount = false,
  onClickAddCoverImage,
  setIsAddMemberOpen,
  isAdmin,
  isMember,
}: ConditionallyRenderSpaceHeaderTitleProps) => {
  const isSmScreen = useSmScreenMediaQuery();
  const { isMobileWebNewSpaceCustomizationUIEnabled } = useMobileWebFlags();
  const spaceCustomizationMobileWebModal = useSpaceCustomizationModal();
  const shouldRenderNewMobileWebUI =
    isSmScreen && isMobileWebNewSpaceCustomizationUIEnabled;

  if (!shouldRenderNewMobileWebUI) {
    return (
      <Dropdown
        direction="bottom-start"
        button={
          <Dropdown.MenuButton>
            <SpaceTitleWithEmoji
              space={space}
              shouldShowMembersCount={shouldShowMembersCount}
            />
            <Icon size={16} type="caret-down-bold" className="text-dark" />
          </Dropdown.MenuButton>
        }
        transitionWrapperClassName="mt-1"
      >
        <SpaceHeaderTitleDropdownFullScreen
          space={space}
          isAdmin={isAdmin}
          isMember={isMember}
          onInviteMember={() => setIsAddMemberOpen(true)}
          onAddCoverImage={onClickAddCoverImage}
        />
      </Dropdown>
    );
  }

  if (shouldRenderNewMobileWebUI) {
    return (
      <button
        type="button"
        className="flex w-full items-center gap-1.5 py-1"
        onClick={() =>
          spaceCustomizationMobileWebModal.show({
            space,
            onClickAddCoverImage,
            setIsAddMemberOpen,
          })
        }
      >
        <SpaceTitleWithEmoji
          space={space}
          shouldShowMembersCount={shouldShowMembersCount}
        />
        <Icon size={16} type="caret-down-bold" className="text-dark" />
      </button>
    );
  }

  return null;
};
